/**
 * Núcleo del brief del cliente (CORE_BRIEF_FIELDS) — una fila por contacto,
 * heredada por todos sus proyectos. Editar un campo heredado escribe acá,
 * nunca una copia local del proyecto.
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { ContactBriefCore } from '@evo-hub/shared';
import { api } from '../lib/api.js';

export interface BriefCorePatch {
  businessName?: string | null;
  industry?: string | null;
  audience?: string | null;
  valueProposition?: string | null;
  tone?: string | null;
  typography?: string | null;
  colors?: { text?: string; attachments?: string[] } | null;
  logo?: string | null;
}

export function useBriefCore(contactId: number | null) {
  return useQuery<{ core: ContactBriefCore | null }>({
    queryKey: ['briefCore', contactId],
    queryFn: () => api.get(`/api/contacts/${contactId}/brief-core`),
    enabled: contactId != null,
  });
}

export function useUpdateBriefCore(contactId: number | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: BriefCorePatch) =>
      api.put<{ core: ContactBriefCore }>(`/api/contacts/${contactId}/brief-core`, patch),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['briefCore', contactId] });
    },
  });
}
